import React from 'react';
import BaseCard from './BaseCard';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import CardHeader from './CardHeader';
import NoteCard from './NoteCard';
import DataTable from '../../../../Elements/DataTable/DataTableFigma';
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import moneyHelper from '../../../../Helpers/moneyHelper';

class EvaluatorFeeCard extends BaseCard {
  FieldsToShowInDataTable() {
    return [
      { label: 'Tier Name', data: 'Name', type: InputTypesEnum.TextReadOnly, tableminWidth: '500px' },
      {
        label: 'Per Evaluation',
        data: 'EvalFeePerEval',
        type: InputTypesEnum.Text2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      {
        label: 'Fee Cost Per Cycle',
        data: 'EvalFeePerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
        fieldClass: '',
      },
      {
        label: 'Fee Cost Annualy',
        data: 'EvalFeeAnnually',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: '% of revenues',
        data: 'EvalFeePct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  SecondFieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: 'TOTAL Eval Bonus for all evaluators (if applicable)', data: '',type: FieldTypesEnum.JustLabel, tableminWidth: '625px', },
      { label: ' ', data: 'EvalBonusPerCycle', type: InputTypesEnum.Text2, tableminWidth: '125px', headerPosition: 'header-text-right', fieldType: 'Decimal', },
      { label: ' ', data: 'EvalBonusAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'EvalBonusPct', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px', headerPosition: 'header-text-right', },
    ];
  }
  BankInformationFieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: 'Per cycle aggregate bank transaction fees to pay evaluators', data: '',type: FieldTypesEnum.JustLabel, tableminWidth: '625px', },
      { label: ' ', data: 'BankChargesPerCycle', type: InputTypesEnum.Text2, tableminWidth: '125px', headerPosition: 'header-text-right', fieldType: 'Decimal', },
      { label: ' ', data: 'BankChargesAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'BankChargesPct', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px', headerPosition: 'header-text-right', },
    ];
  }

  FieldsToShowInFooterDataTable() {
    // prettier-ignore
    return [
      { label: 'TOTAL COST EVALUATORS', tableminWidth: '750px', headerPosition: 'header-text-right' },
      { label: '', data: 'EvalFeeAnnually', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px', headerPosition: 'header-text-right', },
      { label: '', data: 'EvalCostPct', type: InputTypesEnum.TextReadOnly, tableminWidth: '125px', headerPosition: 'header-text-right', },
    ];
  }

  render() {
    const { Tier } = this.props;

    return (
      <div className='card'>
        {
          <CardHeader
            sectionNumber={'3'}
            HeaderText={'EVALUATOR FEE'}
            changeBodyStatus={this.changeBodyStatus}
            bodyactive={this.state.bodyactive}
            subtotal={moneyHelper.toMoneyFormat(this.props.Tier.EvalFeeAnnually, this.props.Tier.PricingDetails.CurrencyCode)}
            subtotalRev={this.props.Tier.EvalCostPct + ' of revenue'}
          />
        }
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              name='EvaluatorFeeNotes'
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.TierList}
              renderInputFieldFunction={this.renderInputField}
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.SecondFieldsToShowInDataTable,
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.BankInformationFieldsToShowInDataTable,
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={Tier.PricingDetails}
              renderInputFieldFunction={this.renderInputField}
              DataTableType='Body'
              smallDataTable={true}
            />
          </div>
        ) : null}
        <footer>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              FieldsToShowInListTable: [],
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={Tier}
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }
}

export default EvaluatorFeeCard;
